<div class="captive-form-wrapper">
  <ng-content></ng-content>
</div>
